import { gql } from '@apollo/client';

/**
 * Fetches full Load Plan V2 data for 3D rendering.
 *
 * results shape:
 * {
 *   warehouseOutDetails: { Id, JobNumber, JobStatus, ... },
 *   TotalLoadPlans: Number,
 *   LoadPlanDetails: [
 *     {
 *       Id, ContainerNumber, ContainerType, Status,
 *       ContainerDimensionLength_Cm,  // Z depth
 *       ContainerDimensionWidth_Cm,   // X width
 *       ContainerDimensionHeight_Cm,  // Y height
 *       ContainerMaxWeightCapacity_Kg,
 *       CurrentTotalWeight_Kg,
 *       CurrentUtilizationPercent,
 *       TotalVolume_CBM,
 *       ContainerTypeDetails: { Id, Code, Description },
 *       AttachedScanIds: [
 *         {
 *           Id,
 *           ScanId_PoPartLocation_Fk,
 *           StackPosition_X_Cm,   // bottom-front-left corner X
 *           StackPosition_Y_Cm,   // bottom-front-left corner Y
 *           StackPosition_Z_Cm,   // bottom-front-left corner Z (0 = door side)
 *           StackingOrder,        // 1 = first placed
 *           RotationOrientation,  // 0 = L×W footprint, 1 = W×L footprint (L and W swapped)
 *           PlacementNotes,
 *           StackingApprovedBy,
 *           StackingApprovedDate,
 *           ScanId: {
 *             Id, ScanId,         // the scan ID string
 *             LengthCm, WidthCm, HeightCm,
 *             WeightKg, WeightLbs,
 *             VolumeCbm, VolumeCft,
 *             Is_Overpack, PackedBy, PackedDate,
 *           }
 *         }
 *       ]
 *     }
 *   ]
 * }
 */
const GET_LOAD_PLAN_V2_FOR_3D = gql`
  query GetLoadPlanV2For3D($warehouseOutId: Int!) {
    getLoadPlanV2DetailsByWarehouseOutId(WarehouseOutId: $warehouseOutId) {
      code
      success
      message
      results
    }
  }
`;

export default GET_LOAD_PLAN_V2_FOR_3D;
